import * as React from 'react';
import { Subtract } from '../sic-lib/utils/typeUtils';

interface WithToggleProps {
    onToggleHandler: () => void;
}

export default function withToggle<P extends WithToggleProps>(
    Component1: (props: P) => JSX.Element,
    Component2: (props: P) => JSX.Element,
) {
    return function ({ ...props }: Subtract<P, WithToggleProps>) {
        const [toggle, setToggle] = React.useState<boolean>(false);

        const handleToggle = () => {
            setToggle(toggle => !toggle);
        };

        return (
            <React.Fragment>
                {!toggle && <Component1 {...(props as P)} onToggleHandler={handleToggle} />}
                {toggle && <Component2 {...(props as P)} onToggleHandler={handleToggle} />}
            </React.Fragment>
        );
    };
}
